<template>
    <div class="bg-primary">
        <div class="container space-1">
            <div class="d-sm-flex justify-content-sm-between align-items-sm-center">
                <div class="mb-3 mb-sm-0">
                    <!-- Breadcrumb -->
                    <ol class="breadcrumb breadcrumb-white breadcrumb-no-gutter mb-0">
                        <li class="breadcrumb-item">
                            <router-link class="breadcrumb-link" :to="{'name': 'home'}">Accueil</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Profil</li>
                    </ol>
                    <!-- End Breadcrumb -->
                </div>

                <!-- Edit Profile -->
                <router-link class="btn btn-sm btn-soft-white transition-3d-hover"
                             :to="{'name': 'editProfile'}">
                    <span class="fas fa-user-cog small mr-2"></span>
                    Editer le profil
                </router-link>
                <!-- End Edit Profile -->
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "EditProfileInvite"
    }
</script>

<style scoped>

</style>